import React from 'react';
import { useFormikContext } from 'formik';
import { EMOJI_SETS } from '../EvaluationScaleConfig';

const EmojiScalePreview = ({ question, fieldName, sendSurvey, outOfDate }) => {
  const { setFieldValue, values } = useFormikContext();
  const disabled = !sendSurvey || outOfDate;

  const choices = (question.questionChoicesAttributes || [])
    .filter(c => !c._destroy)
    .sort((a, b) => a.position - b.position);

  const n = choices.length;
  const emojis = EMOJI_SETS[n] || EMOJI_SETS[5];

  const currentValue = values?.employeeSurvey?.employeeQuestionChoicesAttributes?.find?.(
    eqc => eqc?.questionId === question.id
  )?.questionChoiceId;

  const handleSelect = choiceId => {
    if (disabled) return;
    setFieldValue(`${fieldName}[questionChoiceId]`, choiceId);
  };

  return (
    <div className="eval-emoji-preview-row">
      {choices.map((choice, idx) => {
        const choiceKey = choice.id || choice.position;
        const isSelected = String(currentValue) === String(choiceKey);
        const className = ['eval-emoji-preview-item', isSelected ? 'selected' : '', disabled ? 'disabled' : '']
          .filter(Boolean)
          .join(' ');

        return (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div key={choiceKey} className={className} onClick={() => handleSelect(choiceKey)}>
            <span className="eval-emoji-preview-icon">{emojis[idx] || '😐'}</span>
            {choice.label && <span className="eval-emoji-preview-label">{choice.label}</span>}
          </div>
        );
      })}
    </div>
  );
};

export default EmojiScalePreview;
